import { Competition } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import { fetchClientAtom } from '@/atoms/queries/client';
import { createLookup } from '@/utils/array';
import { unwrappedGenderAtom } from './userConfigs';

const rawCompetitionsAtom = atomWithSuspenseQuery(get => {
  const { fetch } = get(fetchClientAtom);
  const queryKey = ['competitions', get(unwrappedGenderAtom)] as const;
  const queryFn = async ({ queryKey: [, gender] }: { queryKey: typeof queryKey }) => {
    if (!gender) {
      return [];
    }

    return (await fetch(`/competitions?eq[gender]=${gender}`)) as Promise<Competition[]>;
  };

  return { queryKey, queryFn };
});

export const competitionsAtom = atom(async get =>
  // This is rather annoying, but I called the field has_360 on the competitions endpoint
  // (which makes sense since the boolean represents whether the competition has 360 data).
  // However, the field on our dropdown options is is_360, so I'm just mapping this to that
  // here to avoid needing to deal with two different field names.
  // has_physical gets the same treatment, for the same reason.
  (await get(rawCompetitionsAtom)).data.map(c => ({
    ...c,
    is_360: c.has_360,
    is_physical: c.has_physical,
  })),
);

/**
 * A lookup map of competition_id to Competition object. Use this instead of doing a find on the
 * competitionsAtom array.
 */
export const competitionLookupAtom = atom(async get => createLookup(await get(competitionsAtom), 'competition_id'));
